import React, { useState } from "react";
import { 
  Typography, 
  Row, 
  Col, 
  Card, 
  Form, 
  Input, 
  Button, 
  message,
  Space,
  Divider
} from "antd";
import { 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined, 
  ClockCircleOutlined,
  SendOutlined,
  UserOutlined,
  MessageOutlined
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

const Contact = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Préparer le contenu de l'email
      const { name, email, phone, subject, message: messageContent } = values;
      
      const emailSubject = subject ? `[Contact DOMOELEC] ${subject}` : '[Contact DOMOELEC] Nouveau message';
      
      const emailBody = `
Bonjour,

Vous avez reçu un nouveau message depuis le formulaire de contact du site DOMOELEC :

Nom : ${name}
Email : ${email}
Téléphone : ${phone || 'Non renseigné'}
Sujet : ${subject || 'Non renseigné'}

Message :
${messageContent}

---
Ce message a été envoyé automatiquement depuis le site web DOMOELEC.
      `.trim();

      // Créer le lien mailto
      const mailtoLink = `mailto:contact@domoelec.ma?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
      
      // Ouvrir le client email par défaut
      window.open(mailtoLink, '_blank');
      
      message.success('Votre client email s\'ouvre pour envoyer le message à contact@domoelec.ma');
      form.resetFields();
    } catch (error) {
      message.error('Erreur lors de l\'ouverture du client email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' ,padding: '30px 24px'}}>
        {/* Title Section */}
  <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={1} style={{ 
            fontSize: '48px', 
            fontWeight: 700, 
            color: '#000',
            marginBottom: '20px'
          }}>
            CONTACT
          </Title>
        
      </div>

      {/* Content Section */}
      <div style={{ maxWidth: 1170, margin: '0 auto', padding: '0px 4px' }}>
        <Row gutter={[32, 32]}>
          {/* Contact Form */}
          <Col xs={24} lg={14}>
            <Card 
              title={
                <Space>
                  <MessageOutlined style={{ color: '#1890ff' }} />
                  <span>Écrivez-nous</span>
                </Space>
              }
              style={{ height: '100%' }}
              styles={{ 
                body: { padding: '32px' },
                header: { fontSize: '1.5rem', fontWeight: 600 }
              }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                size="large"
              >
                <div style={{ 
                  background: '#e6f7ff', 
                  border: '1px solid #91d5ff', 
                  borderRadius: '6px', 
                  padding: '12px 16px', 
                  marginBottom: '24px',
                  fontSize: '14px'
                }}>
                  <Text style={{ color: '#1890ff' }}>
                    💡 <strong>Comment ça marche :</strong> Après avoir rempli le formulaire, 
                    votre client email s'ouvrira automatiquement avec le message pré-rempli 
                    à envoyer à <strong>contact@domoelec.ma</strong>
                  </Text>
                </div>
                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="name"
                      label="Nom"
                      rules={[{ required: true, message: 'Veuillez saisir votre nom' }]}
                    >
                      <Input 
                        prefix={<UserOutlined />} 
                        placeholder="Votre nom complet"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        { required: true, message: 'Veuillez saisir votre email' },
                        { type: 'email', message: 'Email invalide' }
                      ]}
                    >
                      <Input 
                        prefix={<MailOutlined />} 
                        placeholder="votre@email.com"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="phone"
                      label="Téléphone"
                    >
                      <Input 
                        prefix={<PhoneOutlined />} 
                        placeholder="Votre numéro de téléphone"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="subject"
                      label="Sujet"
                    >
                      <Input 
                        placeholder="Sujet de votre message"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  name="message"
                  label="Message"
                  rules={[{ required: true, message: 'Veuillez saisir votre message' }]}
                >
                  <TextArea 
                    rows={6} 
                    placeholder="Décrivez votre projet ou votre demande..."
                    maxLength={1000}
                  />
                </Form.Item>

                <Form.Item style={{ textAlign: 'center' }}>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={loading}
                    icon={<SendOutlined />}
                    size="middle"
                    style={{ minWidth: '200px' }}
                  >
                    Envoyer le message
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>

          {/* Contact Information */}
          <Col xs={24} lg={10}>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              {/* Coordonnées */}
              <Card
                title={
                  <Space>
                    <EnvironmentOutlined style={{ color: '#52c41a' }} />
                    <span>Coordonnées</span>
                  </Space>
                }
                styles={{ 
                  body: { padding: '24px' },
                  header: { fontSize: '1.3rem', fontWeight: 600 }
                }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <div>
                    <Text strong>Adresse :</Text>
                    <br />
                    <Text>47 Rue Des Orangers, Mag Res Eden Tower, Ain Sebaa - Casablanca</Text>
                  </div>
                  <Divider style={{ margin: '12px 0' }} />
                  <div>
                    <Text strong>Téléphone :</Text>
                    <br />
                    <Text copyable>05223-40659</Text>
                  </div>
                  <Divider style={{ margin: '12px 0' }} />
                  <div>
                    <Text strong>Email :</Text>
                    <br />
                    <Text copyable>contact@domoelec.ma</Text>
                  </div>
                </Space>
              </Card>

              {/* Horaires */}
              <Card
                title={
                  <Space>
                    <ClockCircleOutlined style={{ color: '#fa8c16' }} />
                    <span>Horaires</span>
                  </Space>
                }
                styles={{ 
                  body: { padding: '24px' },
                  header: { fontSize: '1.3rem', fontWeight: 600 }
                }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <div>
                    <Text strong>Lundi - Vendredi</Text>
                    <br />
                    <Text>9h00 - 18h00</Text>
                  </div>
                  <Divider style={{ margin: '12px 0' }} />
                  <div>
                    <Text strong>Samedi</Text>
                    <br />
                    <Text>9h00 - 12h30</Text>
                  </div>
                  <Divider style={{ margin: '12px 0' }} />
                  <div>
                    <Text strong>Dimanche</Text>
                    <br />
                    <Text type="secondary">Fermé</Text>
                  </div>
                </Space>
              </Card>
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Contact;
